import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { CoreMenuItem } from '@core/types';

@Component({
	selector: '[core-menu-vertical-item]',
	templateUrl: './item.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CoreMenuVerticalItemComponent {
	@Input()
	item: CoreMenuItem;
}
